import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import NavTab, { NavTabItem } from 'partial/components/NavTab';
import Table from 'partial/components/Table';
import Button from 'partial/components/Button';
import { useDebouceEffect } from 'partial/form/hooks';
import Pagination from 'partial/components/Pagination';
import FormInlineInput from 'partial/form/FormInlineInput';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import HistogramRange from 'partial/components/HistogramRange';
import { MdOutlineReceipt } from 'react-icons/md';
import { HiOutlinePencil, HiOutlineSearch } from 'react-icons/hi';
// import { useInvoiceList } from '../hooks';

const useInvoiceList = () => [
  false,
  [
    {
      id: 'invoice-1234',
      date: 'Dec 01, 2021',
      amount: '1,000.00',
      name: 'Juan Dela Cruz',
      email: 'juun@email.com',
    },
  ],
];

// const STATUS_OPTIONS = [
//   { label: 'PENDING', value: 'PENDING' },
//   { label: 'PROCESSED', value: 'PROCESSED' },
// ];

function Filter({ onSubmit, value }) {
  const [form, setForm] = React.useState(value);
  useDebouceEffect(form.keyword, (keyword) => {
    onSubmit((state) => ({
      ...state,
      keyword,
    }));
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };
  const location = useLocation();
  const history = useHistory();
  const handleCreate = () => {
    history.push(`${location.pathname}/new-id`); // TOOD: trigger create then redirect
  };
  const match = useRouteMatch();
  return (
    <div className="pt-5">
      <div className="space-y-2 mb-4 pb-4 mx-2 border-b">
        <div className="title-h1">
          Send an invoice in minutes—no code required
        </div>
        <div className="text-base text-gray-500">
          Get started quickly or use the Invoicing API and advanced features to
          automate your workflow.
        </div>
      </div>
      <NavTab className="mx-0">
        <NavTabItem to={`${match.url}/`} label="All Invoices" count="39" />
        <NavTabItem to={`${match.url}/draft`} label="Draft" />
        <NavTabItem to={`${match.url}/outstanding`} label="Outstanding" />
        <NavTabItem to={`${match.url}/past`} label="Past Due" />
        <NavTabItem to={`${match.url}/paid`} label="Paid" />
      </NavTab>
      <form
        className="flex items-center justify-between border-t pt-4 -mt-px"
        onSubmit={handleSubmit}
      >
        <div className="inline-field flex items-center space-x-1">
          <FormInlineInput
            name="keyword"
            onChange={setForm}
            value={form.keyword}
            placeholder="Search Invoice"
            icon={HiOutlineSearch}
          />
          <HistogramRange
            onChange={() => {}}
            defaultMode="month"
            defaultValue={dayjs().format('YYYY-MM-DD')}
            switchMode={false}
            navigateButton={false}
            panelClassName="right-0"
          />
        </div>
        <div>
          <Button
            primary
            icon={MdOutlineReceipt}
            size="sm"
            onClick={handleCreate}
          >
            Create Invoice
          </Button>
        </div>
      </form>
    </div>
  );
}

Filter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(Object).isRequired,
};

function InvoiceTable({ filter: otherFilter }) {
  const match = useRouteMatch();
  const history = useHistory();
  const [raw, setFilter] = React.useState({
    keyword: '',
    'type[]': '',
    'entry[]': '',
    page: 1,
    sort: 'created_at:desc',
  });
  const filter = React.useMemo(
    () => ({
      ...raw,
      ...otherFilter,
    }),
    [raw, otherFilter]
  );
  const [isLoading, list, pager] = useInvoiceList(filter);
  const tableFormat = React.useMemo(() => {
    const handleEdit = (row) => (e) => {
      e.preventDefault();
      history.push(`${match.url}/${row.id}`);
    };
    const cols = [
      {
        label: 'Date/Time',
        id: 'date',
        key: 'date',
      },
      { label: 'Reference no.', id: 'id', key: 'id' },
    ];
    cols.push({ label: 'Bill To', id: 'name', key: 'name' });
    cols.push({ label: 'Email', id: 'email', key: 'email' });
    cols.push({ label: 'Amount', id: 'amount', key: 'amount' });
    cols.push({
      label: 'Action',
      id: 'action',
      key: (row) => (
        <div>
          <a href="/" className="link-default" onClick={handleEdit(row)}>
            <HiOutlinePencil className="w-3 h-3" />
            <span>Edit</span>
          </a>
        </div>
      ),
    });
    return cols;
  }, [match, history]);
  return (
    <>
      <div className="bg-white rounded-t-lg rounded-b-lg shadow-primary-md">
        <div className="p-3">
          <Filter onSubmit={setFilter} value={raw} />
        </div>
        <div className="flex flex-col" style={{ height: 400 }}>
          <Table
            isLoading={isLoading}
            data={list}
            format={tableFormat}
            onSort={setFilter}
            sort={raw.sort}
          />
        </div>
        <Pagination onChange={setFilter} value={pager} />
      </div>
    </>
  );
}

InvoiceTable.defaultProps = {
  filter: {},
};

InvoiceTable.propTypes = {
  filter: PropTypes.instanceOf(Object),
};

export default InvoiceTable;
